module.exports = __webpack_public_path__ + "bootleggeres_coffee_box_mockup_packaging_design_corrugated_box.jpg?78a050a4a4ff0d012df86577ad553657";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggeres_coffee_box_mockup_packaging_design_corrugated_box.jpg
// module id = 22
// module chunks = 0